import React from "react";
import { Link } from "react-router-dom";

interface GlobalDeleteModalProps {
  id?: string;
  title?: string;
  message?: string;
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const Delete: React.FC<GlobalDeleteModalProps> = ({
  id = "globalDeleteModal",
  title = "Remove Item ?",
  message = "Are you sure you want to delete this item ?",
  show,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      id={id}
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* Close button */}
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="modal-body">
            <div className="text-center">
              <div className="alert alert-danger" role="alert">
                <strong>{title}</strong>
                <div>{message}</div>
              </div>

              <div className="col-lg-12 text-center modal-btn mt-3">
                <Link
                  to="#"
                  className="btn btn-soft-secondary me-2"
                  onClick={onCancel}
                >
                  Cancel
                </Link>

                {title != "Fail To Delete" && (
                  <Link
                    to="#"
                    className="btn btn-soft-danger"
                    onClick={onConfirm}
                  >
                    Yes
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Delete;
